import { mapMutations } from 'vuex';
import { ADD_EXPANDED_ITEM_INTO_MENU, REMOVE_EXPANDED_ITEM_FROM_MENU } from '@/store/mutation-types';

export const itemMixin = {
  data() {
    return {
      active: false,
      childActive: false,
      itemShow: false,
    };
  },
  created() {
    this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false;
    this.childActive = this.item && this.hasChild ? this.isChildActive(this.item.child) : false;
    this.itemShow = this.show;
  },
  methods: {
    ...mapMutations('app', {
      addExpandedItem: ADD_EXPANDED_ITEM_INTO_MENU,
      removeExpandedItem: REMOVE_EXPANDED_ITEM_FROM_MENU,
    }),
    toggleDropdown() {
      this.show = !this.itemShow;
    },
    isLinkActive(item) {
      return this.matchRoute(item.href) || this.isAliasActive(item);
    },
    isChildActive(child) {
      child.forEach((item) => {
        if (this.isLinkActive(item)) {
          return true;
        }
        if (item.hasChild) {
          if (this.isChildActive(item.child)) {
            return true;
          }
        }
      });
      return false;
    },
    isAliasActive(item) {
      if (item.alias) {
        if (Array.isArray(item.alias)) {
          item.alias.forEach((alias) => {
            if (this.matchRoute(alias)) {
              return true;
            }
          });
          return false;
        }
        return this.matchRoute(item.alias);
      }
      return false;
    },
    matchRoute(route) {
      if (this.$route) {
        if (typeof route === 'object') {
          return this.$route.fullPath.endsWith(route.path)
            || this.$route.params.placeId === route.params.placeId;
        }
        return this.$route.fullPath.endsWith(route);
      }
      return window.location.href.endsWith(route);
    },
    expandClickEvent(event) {
      event.preventDefault();
      this.toggleDropdown();
    },
    clickEvent(event) {
      this.emitItemClick(event, this.item);

      if ((!this.item.href && !this.hasChild) || this.item.disabled) {
        event.preventDefault();
        return;
      }
    },
  },
  computed: {
    isRouterLink() {
      return this.$router && this.item && this.item.href !== undefined;
    },
    hasChild() {
      return this.item.child && this.item.child.length > 0;
    },
    show: {
      get() {
        return (this.item && this.$store.state.app.menuExpandedItems[this.item.id]) || false;
      },
      set(value) {
        if (value) {
          this.addExpandedItem(this.item);
          this.itemShow = true;
        } else {
          this.removeExpandedItem(this.item);
          this.itemShow = false;
        }
      },
    },
  },
  watch: {
    $route() {
      this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false;
      this.childActive = this.item && this.hasChild ? this.isChildActive(this.item.child) : false;
    },
  },
  inject: ['showChild', 'showOneChild', 'emitActiveShow', 'activeShow', 'emitItemClick', 'enableCollapsing'],
};

export const animationMixin = {
  methods: {
    expandEnter(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    expandAfterEnter(el) {
      el.style.height = 'auto';
    },
    expandBeforeLeave(el) {
      if (this.isCollapsed) {
        el.style.display = 'none';
        return;
      }
      el.style.height = `${el.scrollHeight}px`;
    },
  },
};
